/* tslint:disable */
/* eslint-disable */
/**
 * Stadia Maps Geospatial APIs
 * The Stadia Maps Geospatial APIs provide you with the data you need to build awesome applications.
 *
 * The version of the OpenAPI document: 9.3.0
 * Contact: support@stadiamaps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 * A point geometry.
 * @export
 * @interface Point
 */
export interface Point {
  /**
   *
   * @type {Array<number>}
   * @memberof Point
   */
  coordinates: Array<number>;
  /**
   *
   * @type {string}
   * @memberof Point
   */
  type: string;
}

/**
 * Check if a given object implements the Point interface.
 */
export function instanceOfPoint(value: object): value is Point {
  if (!("coordinates" in value) || value["coordinates"] === undefined)
    return false;
  if (!("type" in value) || value["type"] === undefined) return false;
  return true;
}

export function PointFromJSON(json: any): Point {
  return PointFromJSONTyped(json, false);
}

export function PointFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): Point {
  if (json == null) {
    return json;
  }
  return {
    coordinates: json["coordinates"],
    type: json["type"],
  };
}

export function PointToJSON(json: any): Point {
  return PointToJSONTyped(json, false);
}

export function PointToJSONTyped(
  value?: Point | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    coordinates: value["coordinates"],
    type: value["type"],
  };
}
